// Debounce a rapidly-changing value (a search box) before it reaches a query
// key. Shared across areas so no screen re-invents it.
//
// Why it matters here: TanStack Query keys off the value, so an undebounced
// controlled search input fires ONE request per keystroke. On the import row
// grid each of those is a substring scan over a table that can hold a million
// rows (spec 02 §2.7), so typing a 12-character SKU used to cost twelve of them.
// The input stays controlled and instant; only the value the query sees waits.

import { useEffect, useState } from "react";

export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounced(value);
    }, delayMs);
    return () => {
      clearTimeout(timer);
    };
  }, [value, delayMs]);
  return debounced;
}
